// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xuUG","index":"styles_index__1K7MG"};